export class FormFloatLabel {
  constructor() {}

  init() {
    const controls = document.querySelectorAll('.form-float-label-control');
    controls.forEach((el) => {
      el.addEventListener('blur', () => {
        if (el.value) {
          el.classList.add('filled');
        } else {
          el.classList.remove('filled');
        }
      });
    });
  }
}
